<template>
  <div>
    <v-card
      :color="isChosen && isDrag ? 'grey lighten-2' : 'none'"
      width="600px"
    >
      <v-form v-model="validGameForm" ref="gameForm">
        <v-layout row pa-2>
          <!-- game id -->
          <template>
            <v-flex xs1 pt-2 pl-2 pr-2>
              <v-icon medium>{{ gameIcon[type] }}</v-icon>
            </v-flex>
            <v-flex xs2 pt-2 pl-2 pr-2>
              <h4>{{ $tc('gameFormCard.game', orderGame) }}</h4>
            </v-flex>
            <v-flex
              pt-2
              pl-2
              pr-2
              v-if="instruction.text[langEdition].length !== 0"
            >
              {{ instruction.text[langEdition] }}
            </v-flex>
            <v-flex pt-2 pl-2 pr-2 v-else>
              {{ $tc(`gameFormCard.gameType.${type}`) }}
            </v-flex>
          </template>

          <!--v-spacer/-->

          <!-- actions -->
          <v-flex layout align-center>
            <v-spacer />

            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <v-icon
                  v-on="on"
                  color="primary"
                  class="pointerClass"
                  medium
                  @pointerdown="elementChosenToDrag"
                >
                  mdi-swap-vertical
                </v-icon>
              </template>
              <span>{{ $t('gameFormCard.tooltips.drag') }}</span>
            </v-tooltip>

            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <v-icon v-on="on" color="red" @click="deleteGame()"
                  >mdi-close
                </v-icon>
              </template>
              <span>{{ $t('gameFormCard.tooltips.delete') }} </span>
            </v-tooltip>
          </v-flex>
        </v-layout>

        <v-divider />

        <v-layout column pl-4 pt-2 pr-4 v-if="!isDrag && !isChosen">
          <!-- gameType dialog -->
          <v-dialog
            style="min-height: 70%"
            v-model="isGameTypeDialogOpen"
            width="60%"
            min-height="70%"
            persistent
          >
            <v-card height="100%" style="overflow-y: auto !important">
              <v-flex layout align-center justify-center>
                <v-card-title
                  class="headline"
                  style="padding-top: 10px; padding-bottom: 10px"
                  primary-title
                >
                  {{ $t(`gameFormCard.chooseGameType`) }}
                </v-card-title>
                <!-- <buoy-btn/> -->
              </v-flex>
              <v-layout row>
                <v-flex column xs6>
                  <v-radio-group
                    :class="[
                      'missionForm__game mt-0',
                      langEdition !== langsEdited[0] ? 'readOnlyClass' : null,
                    ]"
                    v-model="type"
                    :mandatory="false"
                    row
                    @click="changeGameType()"
                  >
                    <!-- action games -->
                    <v-flex layout row wrap align-start>
                      <v-card-text
                        ><h3>
                          {{ $t(`gameFormCard.actionGames`) }}
                        </h3></v-card-text
                      >

                      <v-radio
                        style="width: 60px"
                        v-for="actionGame in actionGames"
                        :key="actionGame"
                        :value="actionGame"
                        :disabled="
                          hasMissionGoToGame && actionGame === 'goTo'
                            ? true
                            : false
                        "
                      >
                        <v-layout slot="label" column>
                          <div
                            class="MissionForm__gameIcon elevation-2"
                            :style="
                              hasMissionGoToGame && actionGame === 'goTo'
                                ? 'background-color: #e0e0e0;'
                                : null
                            "
                            v-bind:class="{
                              'MissionForm__gameIcon--selected':
                                type === actionGame,
                            }"
                          >
                            <v-icon medium>{{ gameIcon[actionGame] }} </v-icon>
                            <!--v-icon 
                              v-if="isPremiumGame(actionGame)"
                              small color="yellow darken-2">
                              mdi-star
                              </v-icon-->
                          </div>
                          <span class="gameTypeLabel"
                            >{{ $t(`gameFormCard.gameType.${actionGame}`) }}
                          </span>
                        </v-layout>
                      </v-radio>
                    </v-flex>
                    <!--  strategy games -->

                    <v-card-text>
                      <!--v-icon small color="yellow darken-2">mdi-star</!--v-icon-->
                      <h3>{{ $t(`gameFormCard.strategyGames`) }}</h3>
                    </v-card-text>
                    <v-flex layout row wrap align-start>
                      <v-radio
                        style="width: 60px"
                        v-for="strategyGame in strategyGames"
                        :key="strategyGame"
                        :value="strategyGame"
                      >
                        <v-layout slot="label" column>
                          <div
                            class="MissionForm__gameIcon elevation-2"
                            v-bind:class="{
                              'MissionForm__gameIcon--selected':
                                type === strategyGame,
                            }"
                          >
                            <v-icon medium>{{ gameIcon[strategyGame] }}</v-icon>
                            <!--v-icon 
                          v-if="isPremiumGame( strategyGame)"
                          small color="yellow darken-2">
                          mdi-star
                          </v-icon-->
                          </div>
                          <span class="gameTypeLabel"
                            >{{ $t(`gameFormCard.gameType.${strategyGame}`) }}
                          </span>
                        </v-layout>
                      </v-radio>
                    </v-flex>

                    <!-- survey games -->
                    <v-card-text>
                      <h3>{{ $t('gameFormCard.surveyGames') }}</h3>
                    </v-card-text>
                    <v-flex layout row wrap align-start>
                      <v-radio
                        style="width: 60px"
                        v-for="surveyGame in surveyGames"
                        :key="surveyGame"
                        :value="surveyGame"
                      >
                        <v-layout slot="label" column>
                          <div
                            class="MissionForm__gameIcon elevation-2"
                            v-bind:class="{
                              'MissionForm__gameIcon--selected':
                                type === surveyGame,
                            }"
                          >
                            <v-icon medium>{{ gameIcon[surveyGame] }}</v-icon>
                            <!--v-icon 
                                v-if="isPremiumGame(surveyGame)"
                                small color="yellow darken-2">
                                mdi-star
                                </v-icon-->
                          </div>
                          <span class="gameTypeLabel"
                            >{{ $t(`gameFormCard.gameType.${surveyGame}`) }}
                          </span>
                        </v-layout>
                      </v-radio>
                    </v-flex>
                  </v-radio-group>
                </v-flex>

                <v-flex column xs6 style="padding-left: 2em">
                  <v-card-text>
                    <p>{{ $t(`gameFormCard.gameTypeDescription.${type}`) }}</p>
                  </v-card-text>
                  <gif :gameGif="gameGif[type]"> </gif>
                </v-flex>
              </v-layout>
            </v-card>

            <v-card-actions
              style="background-color: white"
              layout
              row
              pl-2
              pr-2
              pt-4
            >
              <!-- <v-flex layout row  pl-2 pr-2 pt-4> -->
              <v-btn
                color="primary"
                outline
                flat
                class="text-none"
                @click="deleteGame"
              >
                <span>{{ $t('premiumDialog.cancelButtonText') }}</span>
              </v-btn>
              <v-spacer></v-spacer>
              <v-btn
                v-if="
                  !access.includes('premiumGames') &&
                  premiumGames.includes(type)
                "
                color="primary"
                class="text-none"
                @click="openPremiumDialog = true"
              >
                <span>{{ $t('gameFormCard.goPremium') }}</span>
              </v-btn>
              <v-btn
                v-else
                color="primary"
                class="text-none"
                @click="confirmGame"
              >
                <span>{{ $t('pathManagement.confirm') }}</span>
              </v-btn>
              <!-- </v-flex> -->
            </v-card-actions>
          </v-dialog>

          <premium-dialog
            v-if="openPremiumDialog"
            :isTextDialogOpen="openPremiumDialog"
            :title="premiumTitle"
            @confirm="closePremium()"
            @cancel="closePremium()"
          >
          </premium-dialog>

          <!-- instruction -->
          <v-layout row>
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <v-text-field
                  :label="$t('gameFormCard.instruction')"
                  @blur="updateInstructionText"
                  v-model="instruction.text[langEdition]"
                  :rules="rules.instruction"
                  :counter="maxCharInstruction"
                  :hint="
                    langEdition !== locale ? instruction.text[locale] : null
                  "
                  :persistent-hint="showHint"
                  v-on="on"
                >
                  <language-translator
                    v-if="locale !== langEdition"
                    :langEdition="langEdition"
                    :textToTranslate="instruction.text[locale]"
                    :type="'instruction'"
                    @text-translated="updateTranslatedText"
                    slot="append"
                  >
                  </language-translator>
                </v-text-field>
              </template>
              <span> {{ $t('gameFormCard.tooltips.instruction') }} </span>
            </v-tooltip>
          </v-layout>

          <v-expand-transition>
            <v-layout v-if="isInstructionsExpanded" row class="justify-center">
              <v-flex column>
                <image-input
                  :label="$t('gameFormCard.image')"
                  :showHint="showHint"
                  :default="instruction.picture"
                  :isBorderThick="true"
                  :langEdition="langEdition"
                  @change-image-input="updateInstructionImage"
                  @error="onImageError"
                />
              </v-flex>

              <v-flex column class="align-center">
                <media-input
                  style="top: 30%"
                  :label="$t('gameFormCard.explanationMedia')"
                  :default="instruction.media"
                  :type="instruction.media.type"
                  :name="instruction.media.name"
                  :width="150"
                  @change-media-input="updateInstructionMedia"
                  @uploading-media="uploadingMedia"
                >
                </media-input>
              </v-flex>
            </v-layout>
          </v-expand-transition>

          <v-flex layout row>
            <!-- instruction media -->
            <!-- <v-flex column
          style="max-width: 30%;">
            <v-flex layout row
            v-if="gamesWithOptionalImage.includes(type)">
            <image-input
              :label="$t('gameFormCard.image')"
              :showHint="showHint"
              :default="instruction.picture"
              :isBorderThick="true"
              :langEdition="langEdition"
              @change-image-input="updateInstructionImage"
              @error="onImageError"
            />
            </v-flex>
            <v-flex layout row
            v-if="gamesWithOptionalMedia.includes(type)">
            <media-input
                :label="$t('gameFormCard.instructionMedia')"
                :default="instruction.media.url"
                :type="instruction.media.type"
                :name="instruction.media.name"
                :width="150"
                @change-media-input="updateMedia"
              >
            </media-input>
            </v-flex>
          </v-flex> -->

            <!-- mcq -->
            <v-flex
              v-if="type == 'mcq' || type == 'mcqSurvey'"
              layout
              align-center
              ml-4
              column
            >
              <p>{{ $t('gameFormCard.answer') }}</p>
              <game-mcq
                v-for="index in parametersMcq.answers.length"
                :key="index - 1"
                :answerId="index - 1"
                :answer="parametersMcq.answers[index - 1]"
                :possibleToDelete="
                  parametersMcq.answers.length > 2 &&
                  parametersMcq.answers.length === index
                "
                :readOnly="langEdition !== langsEdited[0]"
                :gameType="type"
                :langEdition="langEdition"
                :showHint="showHint"
                @update-answer-text="updateAnswerText"
                @update-answer-value="updateAnswerValue"
                @delete-answer="deleteAnswer"
              />
              <div
                v-if="parametersMcq.answers.length < maxAnswers"
                class="addGame pointerClass"
              >
                <v-flex
                  layout
                  align-center
                  justify-center
                  style="height: 48px"
                  @click="addAnswer(type)"
                >
                  <v-icon large color="primary">mdi-plus</v-icon>
                </v-flex>
              </div>
            </v-flex>

            <!-- anagram -->
            <v-flex v-if="type === 'anagram'" layout align-center ml-4 column>
              <p v-if="type === 'anagram'">{{ $t('gameFormCard.answer') }}</p>
              <game-text
                :gameId="gameId"
                :gameType="type"
                :answer="gameTextAnswer"
                :langEdition="langEdition"
                :maxTextLength="maxCharTextGameAnswer"
                @update-answer-text="updateTextGameAnswer"
              >
              </game-text>
            </v-flex>

            <!-- textInput with tags -->

            <v-flex v-if="type === 'textInput'" layout align-center ml-4 column>
              <p>{{ $t('gameFormCard.answerTextInput') }}</p>
              <text-tag
                :answer="gameTextAnswer"
                :langEdition="langEdition"
                :showHint="showHint"
                @update-combo-text="updateTextGameAnswer"
              >
              </text-tag>
            </v-flex>
          </v-flex>

          <!-- puzzle -->

          <v-flex v-if="type === 'puzzle'" layout align-center ml-4 column>
            <p>{{ $t('gameFormCard.puzzleParameters') }}</p>
            <game-puzzle
              :gameId="gameId"
              :gameType="type"
              :parameters="parametersPuzzle"
              :langEdition="langEdition"
              @update-puzzle-image="updatePuzzleImage"
              @update-puzzle-parameters="updatePuzzleParameters"
            >
            </game-puzzle>
          </v-flex>

          <!-- erase picture-->

          <v-flex v-if="type === 'scrapPicture'" layout ml-4 column>
            <p style="align-self: center">
              {{ $t('gameFormCard.scrapPictureParameters') }}
            </p>

            <game-scrap-picture
              :gameId="gameId"
              :gameType="type"
              :parameters="parametersScrap"
              :langEdition="langEdition"
              @update-answer-image="updateScrapPictureAnswerImage"
              @update-cover-picture="updateScrapPictureCoverImage"
              @update-cover-color="updateScrapPictureCoverColor"
              @update-cover-type="updateScrapPictureCoverType"
            >
            </game-scrap-picture>
          </v-flex>

          <!-- take picture-->

          <v-flex v-if="type === 'takePicture'" layout ml-4 column>
            <game-take-picture
              :gameId="gameId"
              :gameType="type"
              :langEdition="langEdition"
              :parameters="parametersTakePicture"
              @update-take-picture-answer="updateTakePictureAnswer"
            >
            </game-take-picture>
          </v-flex>

          <!-- mcq image-->
          <v-flex
            v-if="type === 'mcqImage'"
            layout
            row
            align-center
            justify-center
          >
            <v-flex layout align-center ml-4 column>
              <p>{{ $t('gameFormCard.answer') }}</p>
              <v-flex layout row wrap>
                <game-mcq
                  v-for="index in parametersMcqImage.answers.length"
                  :key="index - 1"
                  :answerId="index - 1"
                  :answer="parametersMcqImage.answers[index - 1]"
                  :possibleToDelete="
                    parametersMcqImage.answers.length > 2 &&
                    parametersMcqImage.answers.length === index
                  "
                  :readOnly="langEdition !== langsEdited[0]"
                  :gameId="gameId"
                  :langEdition="langEdition"
                  :gameType="type"
                  @update-answer-image="updateAnswerImage"
                  @update-answer-value="updateAnswerValue"
                  @delete-answer="deleteAnswer"
                />
              </v-flex>
              <div
                v-if="parametersMcqImage.answers.length < maxAnswers"
                :class="[
                  parametersMcqImage.answers.length === 2
                    ? 'addThirdImage'
                    : 'addFourthImage',
                ]"
              >
                <v-flex
                  row
                  layout
                  align-center
                  justify-center
                  @click="addAnswer(type)"
                >
                  <v-icon large color="primary">mdi-plus</v-icon>
                </v-flex>
              </div>
            </v-flex>
          </v-flex>

          <!-- sort -->
          <v-flex
            layout
            align-center
            justify-center
            column
            v-if="type === 'sort' || type === 'sortImage'"
          >
            <span v-if="type === 'sort'" class="grey--text mb-2">
              {{ $t('gameFormCard.dragInstruction') }}
            </span>
            <span v-else-if="type === 'sortImage'" class="grey--text mb-2">
              {{ $t('gameFormCard.explanationSortImage') }}
            </span>
            <game-sort
              v-for="index in parametersSort.sortElements.length"
              :key="index"
              :langEdition="langEdition"
              :possibleToDelete="
                parametersSort.sortElements.length > 3 &&
                parametersSort.sortElements.length === index
              "
              :elementOrder="index - 1"
              :answer="parametersSort.sortElements[index - 1]"
              :answerId="index - 1"
              :gameType="type"
              :showHint="showHint"
              @update-sort-answer="updateSortAnswer"
              @drag-button-sort-game-click="dragButtonSortGameClick"
              @delete-answer="deleteAnswer"
            >
            </game-sort>

            <div
              v-if="parametersSort.sortElements.length < maxAnswers"
              :class="
                type === 'sort'
                  ? 'addSortGame pointerClass'
                  : 'addSortImageGame pointerClass'
              "
            >
              <v-flex
                layout
                align-center
                justify-center
                @click="addAnswer(type)"
              >
                <v-icon large color="primary">mdi-plus</v-icon>
              </v-flex>
            </div>
          </v-flex>

          <!-- target zone -->
          <v-flex
            layout
            align-center
            justify-center
            column
            v-if="type === 'targetZone'"
          >
            <span class="grey--text mb-2">
              {{ $t('gameFormCard.targetInstruction') }}
            </span>
            <game-target-zone
              :parameters="parametersTargetZone"
              :langEdition="langEdition"
              @update-answer-image="updateTargetZoneImage"
              @update-zone="updateTargetZone"
            >
            </game-target-zone>
          </v-flex>

          <!--flashcode -->

          <v-flex
            layout
            row
            align-center
            class="grey--text"
            pt-2
            style="margin-left: 8%"
            v-if="type === 'flashCode'"
            >{{ $t('gameFormCard.explanationQrCodeLimitation') }}
          </v-flex>
          <v-flex
            layout
            row
            align-center
            justify-center
            v-if="type === 'flashCode'"
          >
            <v-text-field
              v-model="flashCode"
              :rules="rules.flashCode"
              @blur="updateFlashcode"
              :label="$t('gameFormCard.flashCodeValue')"
              outline
              class="flashCodeField"
            ></v-text-field>
            <v-btn @click="isFlashCodeDialogOpen = true" :disabled="!flashCode">
              <v-icon left>mdi-qrcode</v-icon>
              <span>{{ $t('gameFormCard.generateQrcode') }}</span>
            </v-btn>
          </v-flex>

          <!-- flashcode dialog -->
          <qr-code-dialog
            :isFlashCodeDialogOpen="isFlashCodeDialogOpen"
            :qrCodeValue="flashCode"
            :qrCodeName="mission.name[locale]"
            :cancelIsPossible="true"
            :confirmButtonColor="'primary'"
            @close-dialog="isFlashCodeDialogOpen = false"
          />

          <!-- goto -->
          <v-flex layout align-center justify-center v-if="type === 'goTo'">
            <v-btn
              color="primary"
              class="text-none"
              outline
              @click="isLocationDialogOpen = true"
            >
              <v-icon left :color="geolocation ? 'success' : undefined">{{
                locationBtnIcon
              }}</v-icon>
              <span v-if="geolocation">{{ isLocationBtnText }}</span>
              <span v-else>{{ noLocationBtnText }}</span>
            </v-btn>
          </v-flex>
          <!-- location dialog -->
          <v-dialog
            v-model="isLocationDialogOpen"
            width="40%"
            maxCharTextGameAnswer
            lazy
            persistent
          >
            <v-card>
              <v-layout justify-center>
                <v-card-title class="headline">
                  {{ $t('gameFormCard.localisation') }}
                </v-card-title>
              </v-layout>
              <v-layout justify-center>
                <location-picker
                  :defaultLocation="geolocation"
                  :defaultRadius="20"
                  :lngCenter="
                    geolocation
                      ? geolocation.coordinates[0]
                      : pathGeolocation && pathGeolocation.coordinates
                      ? pathGeolocation.coordinates[0]
                      : 2.35
                  "
                  :latCenter="
                    geolocation
                      ? geolocation.coordinates[1]
                      : pathGeolocation && pathGeolocation.coordinates
                      ? pathGeolocation.coordinates[1]
                      : 46.85
                  "
                  :zoomOnClick="16"
                  :color="'#009999'"
                  :parent="'missionCard'"
                  @submit="updateLocation"
                  @cancel="cancelLocationSubmit"
                  @delete-location="deleteLocation"
                />
              </v-layout>
            </v-card>
          </v-dialog>

          <!-- answer rules -->
          <v-flex layout justify-center align-center v-if="rulesToShow">
            <p class="ruleText">
              <span v-for="rule in rulesToShow" :key="rule">
                <span>
                  {{ rule }}
                </span>
                <br />
              </span>
            </p>
          </v-flex>
        </v-layout>

        <!--v-divider v-if="!isDrag && !isChosen"/-->
        <!-- GAME OPTIONS -->
        <v-layout column v-if="!isDrag && !isChosen">
          <v-expansion-panel v-model="hintPanel" expand>
            <v-expansion-panel-content>
              <template v-slot:actions v-if="hasOptions">
                <v-icon color="grey">$vuetify.icons.expand</v-icon>
              </template>
              <template v-slot:actions v-else>
                <v-icon color="primary">done</v-icon>
              </template>
              <template v-slot:header>
                <div class="grey--text">
                  {{ $t('gameFormCard.optionalOptions') }}
                </div>
                <!-- <div class="grey--text">Options facultatives</div> -->
              </template>
              <!--v-divider/
            
            align-with-title-->

              <!-- DEBUT TAB -->
              <v-tabs v-model="optionsTab" fixed-tabs>
                <v-tabs-slider color="primary"></v-tabs-slider>

                <v-tab
                  v-for="tab in optionTabNames"
                  :key="tab.tabRef"
                  :href="'#' + tab.tabRef"
                >
                  <v-badge
                    right
                    bottom
                    color="primary"
                    v-if="objectIsEmpty(tab.tabRef)"
                  >
                    <template v-slot:badge>
                      <v-icon small dark>mdi-check</v-icon>
                    </template>
                    {{ tab.tabName }}
                  </v-badge>
                  <div v-else>{{ tab.tabName }}</div>
                </v-tab>

                <v-tab-item key="instructions" value="instructions">
                  <div class="tab-item-wrapper">
                    <v-card class="mb-4" flat>
                      <v-card-title class="justify-center">{{
                        $t('gameFormCard.options.instructions.title')
                      }}</v-card-title>

                      <!-- --- INSTRUCTIONS --- -->
                      <v-layout
                        row
                        class="justify-center"
                        style="
                          padding-left: 124px !important;
                          padding-right: 124px !important;
                        "
                      >
                        <v-flex column pl-4 pr-4>
                          <image-input
                            :label="
                              $t('gameFormCard.options.instructions.picture')
                            "
                            :showHint="showHint"
                            :default="instruction.picture"
                            :isBorderThick="true"
                            :langEdition="langEdition"
                            @change-image-input="updateInstructionImage"
                            @error="onImageError"
                          />
                        </v-flex>

                        <v-flex column class="align-center" pl-4 pr-4>
                          <media-input
                            style="top: 30%"
                            :label="
                              $t('gameFormCard.options.instructions.media')
                            "
                            :default="instruction.media.url"
                            :type="instruction.media.type"
                            :name="instruction.media.name"
                            :width="150"
                            @change-media-input="updateInstructionMedia"
                            @uploading-media="uploadingMedia"
                          >
                          </media-input>
                        </v-flex>
                      </v-layout>
                    </v-card>
                  </div>
                </v-tab-item>
                <v-tab-item key="hints" value="hints">
                  <v-card class="mb-4" flat>
                    <!--  --- HINTS --- -->
                    <v-card-title class="justify-center">{{
                      $t('gameFormCard.options.hints.title')
                    }}</v-card-title>
                    <!--v-flex layout  row align-center-->
                    <game-hint
                      v-for="index in hints.length"
                      :key="index - 1"
                      :hintId="index - 1"
                      :hint="hints[index - 1]"
                      :possibleToDelete="
                        hints.length > 1 && hints.length === index
                      "
                      :readOnly="langEdition !== langsEdited[0]"
                      :gameType="type"
                      :langEdition="langEdition"
                      :showHint="showHint"
                      @update-hint-text="updateHint"
                      @delete-hint="deleteHint"
                    />

                    <v-flex
                      v-if="hints.length < maxHints"
                      layout
                      justify-center
                      mb-2
                      ml-4
                      addHint
                      pointerClass
                      style="height: 40px"
                      @click="addHint()"
                    >
                      <v-icon large color="primary">mdi-plus</v-icon>
                    </v-flex>

                    <!--/v-flex-->
                    <!--/v-layout-->
                  </v-card>
                </v-tab-item>
                <v-tab-item key="explanations" value="explanations">
                  <v-card flat>
                    <!-- --- EXPLANATIONS --- -->
                    <v-card-title
                      class="justify-center"
                      style="padding-bottom: 2px !important"
                      >{{
                        $t('gameFormCard.options.explanations.title')
                      }}</v-card-title
                    >
                    <v-layout column pl-4 pr-4 fill-height>
                      <v-layout row>
                        <v-tooltip top>
                          <template v-slot:activator="{ on }">
                            <v-textarea
                              v-on="on"
                              @blur="updateExplanation"
                              v-model="explanation[langEdition]"
                              :label="
                                $t('gameFormCard.options.explanations.text')
                              "
                              :rules="rules.explanation"
                              :counter="maxCharExplanation"
                              :hint="
                                langEdition !== locale
                                  ? explanation[locale]
                                  : null
                              "
                              :persistent-hint="showHint"
                            >
                              <language-translator
                                v-if="locale !== langEdition"
                                :langEdition="langEdition"
                                :textToTranslate="explanation[locale]"
                                :type="'explanation'"
                                @text-translated="updateTranslatedText"
                                slot="append"
                              >
                              </language-translator>
                            </v-textarea>
                          </template>
                          <span>
                            {{ $t('gameFormCard.tooltips.explanation') }}
                          </span>
                        </v-tooltip>
                      </v-layout>
                      <v-layout
                        row
                        class="justify-center"
                        style="
                          padding-left: 124px !important;
                          padding-right: 124px !important;
                        "
                      >
                        <v-flex column pl-4 pr-4 fill-height>
                          <image-input
                            :label="
                              $t('gameFormCard.options.explanations.picture')
                            "
                            :showHint="showHint"
                            :default="explanationPicture"
                            :isBorderThick="true"
                            :langEdition="langEdition"
                            @change-image-input="updateExplanationPicture"
                            @error="onImageError"
                          />
                        </v-flex>
                        <v-flex column class="align-center" pl-4 pr-4>
                          <media-input
                            style="top: 30%"
                            :label="
                              $t('gameFormCard.options.explanations.media')
                            "
                            :default="explanationMedia.url"
                            :type="explanationMedia.type"
                            :name="explanationMedia.name"
                            :width="150"
                            @change-media-input="updateExplanationMedia"
                            @uploading-media="uploadingMedia"
                          >
                          </media-input>
                        </v-flex>
                      </v-layout>
                    </v-layout>
                  </v-card>
                </v-tab-item>
              </v-tabs>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-layout>
      </v-form>
    </v-card>
  </div>
</template>

<script>
import GameMcq from './GameMcq';
import GameHint from './GameHint';
import GameSort from './GameSort';
import GameText from './GameText';
import GameScrapPicture from './GameScrapPicture';
import GameTargetZone from './GameTargetZone';
import GamePuzzle from './GamePuzzle.vue';
import GameTakePicture from './GameTakePicture.vue';
import ImageInput from './ImageInput';
import TextTag from './TextTag.vue';
import LocationPicker from './LocationPicker';
import Gif from './Gif';
import LanguageTranslator from '../components/LanguageTranslator.vue';
import PremiumDialog from './PremiumDialog';
import MediaInput from '../components/MediaInput';
import QrCodeDialog from './QrCodeDialog.vue';

export default {
  name: 'gameFormCard',
  components: {
    GameMcq,
    GameHint,
    GameSort,
    GameTargetZone,
    ImageInput,
    LocationPicker,
    //UpcomingFeature,
    Gif,
    LanguageTranslator,
    PremiumDialog,
    MediaInput,
    GameText,
    GameScrapPicture,
    GamePuzzle,
    TextTag,
    GameTakePicture,
    QrCodeDialog,
  },
  props: {
    gameId: {
      type: String,
      default: null,
    },
    numberGames: {
      type: Number,
      default: 0,
    },
    orderGame: {
      type: Number,
      default: 1,
    },
    isDrag: {
      type: Boolean,
      default: false,
    },
    missionId: {
      type: String,
      default: null,
    },
    hasMissionGoToGame: {
      type: Boolean,
      default: false,
    },
    langEdition: {
      type: String,
      default: null,
    },
    langsEdited: {
      type: Array,
      default: null,
    },
    pathGeolocation: {
      type: Object,
      default: null,
    },
    pathId: {
      type: String,
      default: null,
    },
    showHint: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      instructionError: null,
      geolocation: null,
      flashCode: null,
      previousFlachCode: null,
      type: null,
      optionsTab: 'instructions',
      optionTabNames: [
        {
          tabRef: 'instructions',
          tabName: this.$t('gameFormCard.options.instructions.tabName'),
        },
        {
          tabRef: 'hints',
          tabName: this.$t('gameFormCard.options.hints.tabName'),
        },
        {
          tabRef: 'explanations',
          tabName: this.$t('gameFormCard.options.explanations.tabName'),
        },
      ],
      instruction: {
        text: { fr: '', en: '' },
        picture: { url: '', author: '', legend: { fr: '', en: '' } },
        media: { url: '', name: '', type: '' },
      },
      explanation: { fr: '', en: '' },
      explanationPicture: { url: '', author: '', legend: { fr: '', en: '' } },
      explanationMedia: { name: '', type: '', url: '' },
      explanationPanel: [false],
      instructionPanel: [false],
      isInstructionsExpanded: false,
      explanationPicturePanel: [false],
      hints: [
        {
          text: { fr: '', en: '' },
        },
      ],
      hintPanel: [false],
      parametersSort: {
        sortElements: [
          {
            picture: { url: '', author: '', legend: { fr: '', en: '' } },
            text: { fr: '', en: '' },
            expectedPosition: 1,
          },
          {
            picture: { url: '', author: '', legend: { fr: '', en: '' } },
            text: { fr: '', en: '' },
            expectedPosition: 2,
          },
          {
            picture: { url: '', author: '', legend: { fr: '', en: '' } },
            text: { fr: '', en: '' },
            expectedPosition: 3,
          },
        ],
      },
      parametersTextInput: {
        expectedValues: {
          fr: [],
          en: [],
        },
      },
      parametersAnagram: {
        phrase: {
          fr: '',
          en: '',
        },
      },
      parametersPuzzle: {
        nbCol: 0,
        nbRow: 0,
        picture: { url: '', author: '', legend: { fr: '', en: '' } },
      },
      parametersScrap: {
        pictureToDiscover: { url: '', author: '', legend: { fr: '', en: '' } },
        coverPicture: { url: '', author: '', legend: { fr: '', en: '' } },
        coverColorHex: '',
        coverType:''
      },
      parametersMcq: {
        answers: [
          { text: { fr: '', en: '' }, isCorrect: false },
          { text: { fr: '', en: '' }, isCorrect: false },
        ],
      },
      parametersMcqImage: {
        answers: [
          {
            picture: { url: '', author: '', legend: { fr: '', en: '' } },
            isCorrect: false,
          },
          {
            picture: { url: '', author: '', legend: { fr: '', en: '' } },
            isCorrect: false,
          },
        ],
      },
      parametersTakePicture: {
        isAnalysing: false,
        expectedResults: [],
        pictures: [],
      },
      parametersTargetZone: {
        picture: { url: '' },
        zoneRelativeX: null,
        zoneRelativeY: null,
        zoneRelativeWidth: null,
        zoneRelativeHeight: null,
      },
      gameIcon: {
        goTo: 'mdi-map-marker-radius',
        find: 'mdi-eye',
        qrcode: 'mdi-qrcode-scan',
        flashCode: 'mdi-qrcode-scan',
        takePicture: 'mdi-camera',
        survey: 'mdi-comment-question-outline',
        takeSelfie: 'mdi-face',
        targetZone: 'mdi-gesture-double-tap',
        mcq: 'mdi-format-list-checks',
        mcqImage: 'mdi-image-multiple',
        mcqSurvey: 'mdi-account-search',
        sort: 'mdi-sort',
        sortImage: 'mdi-sort',
        scrapPicture: 'mdi-eraser',
        anagram: 'mdi-textbox-password',
        textInput: 'mdi-textbox',
        puzzle: 'mdi-puzzle',
      },
      gameGif: {
        goTo: 'goToGif.gif',
        find: 'findGif.gif',
        flashCode: 'flashCodeGif.gif',
        takePicture: 'takePictureGif.gif',
        survey: 'fake.gif',
        takeSelfie: 'takeSelfieGif.gif',
        targetZone: 'targetZoneGif.gif',
        mcq: 'mcqGif.gif',
        mcqImage: 'mcqImageGif.gif',
        mcqSurvey: 'mcqSurveyGif.gif',
        sort: 'sortGif.gif',
        sortImage: 'fake.gif',
        scrapPicture: 'scrapPictureGif.gif',
        anagram: 'anagramGif.gif',
        textInput: 'textInputGif.gif',
        puzzle: 'puzzleGif.gif',
      },
      mcqTracking: false,
      isGameTypeDialogOpen: false,
      isLocationDialogOpen: false,
      isLocationBtnText: this.$t('pathForm.changeLocation'),
      noLocationBtnText: this.$t('pathForm.chooseLocation'),
      locationBtnIcon: 'mdi-map-marker',
      locationBtnClass: '',
      noCorrectAnswerError: null,
      noAnswerError: null,
      oneAnswerError: null,
      noAnswerTextError: null,
      isFlashCodeDialogOpen: false,
      isChosen: false,
      isDragButtonSortGameClicked: false,
      validGameForm: false,
      maxCharInstruction: 150,
      maxCharExplanation: 900,
      maxCharTextGameAnswer: 40,
      maxPuzzleRow: 5,
      maxPuzzleCol: 5,
      maxCharHint: 150,
      minSortAnswers: 3,
      minMcqAnswers: 2,
      maxAnswers: 4,
      maxHints: 2,
      openPremiumDialog: false,
      premiumTitle: this.$t('premiumDialog.title.premiumGames'),
      gamesWithOptionalImage: [
        'mcq',
        'mcqSurvey',
        'find',
        'anagram',
        'textInput',
      ],
      gamesWithOptionalMedia: ['mcq', 'mcqSurvey'],
      rules: {
        instruction: [
          (instruction) =>
            Boolean(instruction) ||
            this.$t('gameFormCard.rules.instruction.empty'),
          (instruction) =>
            (instruction && instruction.length <= this.maxCharInstruction) ||
            this.$tc(
              'gameFormCard.rules.instruction.length',
              this.maxCharInstruction
            ),
        ],
        explanation: [
          (explanation) =>
            Boolean(!explanation) ||
            (explanation && explanation.length <= this.maxCharExplanation) ||
            this.$tc(
              'gameFormCard.rules.explanation.length',
              this.maxCharExplanation
            ),
        ],
        hint: [
          (hint) =>
            Boolean(!hint) ||
            (hint && hint.length <= this.maxCharHint) ||
            this.$tc('gameFormCard.rules.hint.length', this.maxCharHint),
        ],
        // {
        flashCode: [
          // empty: this.$t('gameFormCard.rules.flashCode.empty'),
          // noLink: this.$t('gameFormCard.rules.flashCode.noLink'),
          (flashCode) =>
            Boolean(flashCode) || this.$t('gameFormCard.rules.flashCode.empty'),
          (flashCode) =>
            (flashCode && !flashCode.startsWith('http')) ||
            this.$t('gameFormCard.rules.flashCode.noLink'),
          //},
        ],
        goTo: {
          geolocation: this.$t('gameFormCard.rules.goTo.geolocation'),
        },
        sort: {
          number: this.$t('gameFormCard.rules.sort.number'),
        },
        sortImage: {
          number: this.$t('gameFormCard.rules.sortImage.number'),
        },
        mcq: {
          number: this.$t('gameFormCard.rules.mcq.number'),
          values: this.$t('gameFormCard.rules.mcq.values'),
        },
        mcqImage: {
          number: this.$t('gameFormCard.rules.mcqImage.number'),
          values: this.$t('gameFormCard.rules.mcqImage.values'),
        },
        targetZone: {
          picture: this.$t('gameFormCard.rules.targetZone.picture'),
          zone: this.$t('gameFormCard.rules.targetZone.zone'),
        },
        anagram: {
          length: this.$tc('gameFormCard.rules.anagram.length', 40), //this.maxCharTextGameAnswer),
          value: this.$t('gameFormCard.rules.anagram.value'),
          spaces: this.$t('gameFormCard.rules.anagram.spaces'),
        },
        textInput: {
          length: this.$tc(
            'gameFormCard.rules.textInput.length',
            this.maxCharTextGameAnswer
          ),
          value: this.$t('gameFormCard.rules.textInput.value'),
          spaces: this.$t('gameFormCard.rules.textInput.spaces'),
        },
        puzzle: {
          value: this.$t('gameFormCard.rules.puzzle.value'),
          picture: this.$t('gameFormCard.rules.puzzle.picture'),
          size: this.$tc('gameFormCard.rules.puzzle.size', 5), // this.maxPuzzleRow)
        },
        scrapPicture: {
          coverColor: this.$t('gameFormCard.rules.scrapPicture.coverColor'),
          coverPicture: this.$t('gameFormCard.rules.scrapPicture.coverPicture'),
          picture: this.$t('gameFormCard.rules.scrapPicture.picture'),
        },
      },
    };
  },
  created() {
    if (this.gameInformations.type) {
      this.setGameValues();
    } else {
      this.createNewGame();
    }
  },
  computed: {
    offer() {
      return this.$store.getters['accounts/currentAccount'].offer || {};
    },
    access() {
      return (
        this.$store.getters['paths/getPathsAccess'][
          this.$route.params.pathId
        ] || []
      );
    },
    gameInformations() {
      return this.$store.getters['missions/getGameById'](this.gameId);
    },
    isFirstGame() {
      return this.orderGame === 1;
    },
    hasOptions() {
      return (
        this.instruction.picture.url === '' &&
        this.instruction.media.url === '' &&
        this.hints[0].text[this.langEdition] === '' &&
        this.explanation[this.langEdition] === '' &&
        this.explanationPicture.url === '' &&
        this.explanationMedia.url === ''
      );
    },
    actionGames() {
      return ['find', 'goTo', 'flashCode', 'takePicture', 'takeSelfie'];
    },
    strategyGames() {
      return [
        'mcq',
        'mcqImage',
        'sort',
        'sortImage',
        'targetZone',
        'textInput',
        'anagram',
        'puzzle',
        'scrapPicture',
      ]; //'anagram', 'textRebus',
    },
    surveyGames() {
      return ['survey', 'mcqSurvey'];
    },
    premiumGames() {
      return [
        'takeSelfie',
        'mcqSurvey',
        'targetZone',
        'textInput',
        'anagram',
        'puzzle',
        'scrapPicture',
        'survey',
      ]; //, 'scrapPicture'];'anagram', 'textRebus',
    },
    invalidGamesInformations() {
      let invalidInformations = [];
      //if (!this.instruction.text[this.langEdition]){
      //    invalidInformations=[... invalidInformations, {gameType: this.type, ruleType: 'instruction'}];
      //  }

      if (this.type === 'goTo') {
        if (!this.geolocation) {
          invalidInformations = [
            ...invalidInformations,
            { gameType: 'goTo', ruleType: 'geolocation' },
          ];
        }
      }
      if (this.type === 'flashCode') {
        if (!this.flashCode) {
          invalidInformations = [
            ...invalidInformations,
            { gameType: 'flashCode', ruleType: 'empty' },
          ];
        } else if (this.flashCode.startsWith('http')) {
          invalidInformations = [
            ...invalidInformations,
            { gameType: 'flashCode', ruleType: 'noLink' },
          ];
        }
      }
      if (this.type === 'sort') {
        let count = this.parametersSort.sortElements.filter((answer) => {
          if (answer.text[this.langEdition]) {
            return answer.text[this.langEdition].trim() !== '';
          }
        });
        if (count.length < this.minSortAnswers) {
          invalidInformations = [
            ...invalidInformations,
            { gameType: 'sort', ruleType: 'number' },
          ];
        }
      }
      if (this.type === 'sortImage') {
        let count = this.parametersSort.sortElements.filter((answer) => {
          if (answer.picture.url) {
            return answer.picture.url.trim() !== '';
          }
        });
        if (count.length < this.minSortAnswers) {
          invalidInformations = [
            ...invalidInformations,
            { gameType: 'sortImage', ruleType: 'number' },
          ];
        }
      }
      if (this.type === 'mcq') {
        let count = this.parametersMcq.answers.filter((answer) => {
          if (answer.text[this.langEdition]) {
            return answer.text[this.langEdition].trim() !== '';
          }
        });
        if (count.length < this.minMcqAnswers) {
          invalidInformations = [
            ...invalidInformations,
            { gameType: 'mcq', ruleType: 'number' },
          ];
        }
        count = this.parametersMcq.answers.find(
          (answer) => answer.isCorrect === true
        );
        if (!count) {
          invalidInformations = [
            ...invalidInformations,
            { gameType: 'mcq', ruleType: 'values' },
          ];
        }
      }
      if (this.type === 'mcqImage') {
        let count = this.parametersMcqImage.answers.filter(
          (answer) => answer.picture.url !== null && answer.picture.url !== ''
        );
        if (count.length < this.minMcqAnswers) {
          invalidInformations = [
            ...invalidInformations,
            { gameType: 'mcqImage', ruleType: 'number' },
          ];
        }
        count = this.parametersMcqImage.answers.find(
          (answer) => answer.isCorrect === true
        );
        if (!count) {
          invalidInformations = [
            ...invalidInformations,
            { gameType: 'mcqImage', ruleType: 'values' },
          ];
        }
      }
      if (this.type === 'targetZone') {
        if (
          !this.parametersTargetZone.picture.url ||
          this.parametersTargetZone.picture.url === ''
        ) {
          invalidInformations = [
            ...invalidInformations,
            { gameType: 'targetZone', ruleType: 'picture' },
          ];
        }
        if (!this.parametersTargetZone.zoneRelativeWidth) {
          invalidInformations = [
            ...invalidInformations,
            { gameType: 'targetZone', ruleType: 'zone' },
          ];
        }
      }
      if (this.type === 'textInput' || this.type === 'anagram') {
        if (
          !this.gameTextAnswer[this.langEdition] ||
          this.gameTextAnswer[this.langEdition].length === 0
        ) {
          invalidInformations = [
            ...invalidInformations,
            { gameType: this.type, ruleType: 'value' },
          ];
        } else if (
          this.gameTextAnswer[this.langEdition].length >
          this.maxCharTextGameAnswer
        ) {
          invalidInformations = [
            ...invalidInformations,
            { gameType: this.type, ruleType: 'length' },
          ];
        }
        if (this.parametersAnagram.phrase[this.langEdition].includes(' ')) {
          invalidInformations = [
            ...invalidInformations,
            { gameType: this.type, ruleType: 'spaces' },
          ];
        }
      }
      if (this.type === 'puzzle') {
        if (
          this.parametersPuzzle.nbCol === 0 ||
          this.parametersPuzzle.nbRow === 0 ||
          this.parametersPuzzle.nbCol === '' ||
          this.parametersPuzzle.nbRow === ''
        ) {
          invalidInformations = [
            ...invalidInformations,
            { gameType: 'puzzle', ruleType: 'value' },
          ];
        }
        if (
          !this.parametersPuzzle.picture.url ||
          this.parametersPuzzle.picture.url === ''
        ) {
          invalidInformations = [
            ...invalidInformations,
            { gameType: 'puzzle', ruleType: 'picture' },
          ];
        }
        if (
          this.parametersPuzzle.nbCol > this.maxPuzzleCol ||
          this.parametersPuzzle.nbRow > this.maxPuzzleRow
        ) {
          invalidInformations = [
            ...invalidInformations,
            { gameType: 'puzzle', ruleType: 'size' },
          ];
        }
      }
      if (this.type === 'scrapPicture') {
        if (this.parametersScrap.coverType==='color' &&
          (
            !this.parametersScrap.coverColorHex ||
            this.parametersScrap.coverColorHex === ''
          )
        ) {
          invalidInformations = [
            ...invalidInformations,
            { gameType: 'scrapPicture', ruleType: 'coverColor' },
          ];
        }
        
        if (this.parametersScrap.coverType==='picture' &&
          ( 
            !this.parametersScrap.coverPicture.url ||
            this.parametersScrap.coverPicture.url === ''
          )
        ) {
          invalidInformations = [
            ...invalidInformations,
            { gameType: 'scrapPicture', ruleType: 'coverPicture' },
          ];
        }
        if (
          !this.parametersScrap.pictureToDiscover.url ||
          this.parametersScrap.pictureToDiscover.url === ''
        ) {
          invalidInformations = [
            ...invalidInformations,
            { gameType: 'scrapPicture', ruleType: 'picture' },
          ];
        }
      }
      this.$emit(
        'valid-game-form',
        invalidInformations.length === 0,
        this.gameId
      ); //  && this.validGameForm,
      return invalidInformations;
    },
    rulesToShow() {
      if (this.invalidGamesInformations.length > 0) {
        let rules = this.invalidGamesInformations.map(
          (information) => this.rules[this.type][information.ruleType]
        );
        return rules;
      }
      return null;
    },
    mission() {
      return this.$store.state.missions.missions[this.missionId];
    },
    locale() {
      return this.$i18n.locale;
    },
    parametersFlashCode() {
      return {
        codeValue: this.flashCode,
      };
    },
    gameTextAnswer() {
      if (this.type === 'anagram') {
        return this.parametersAnagram.phrase;
      } else if (this.type === 'textInput') {
        return this.parametersTextInput.expectedValues;
      }
    },
  },
  methods: {
    isPremiumGame(game) {
      return this.premiumGames.includes(game);
    },
    confirmGame() {
      this.isGameTypeDialogOpen = false;
      this.updateGame();
    },
    updateGame() {
      let game = {
        gameId: this.gameId,
        instruction: this.instruction,
        type: this.type,
        explanation: this.explanation,
        explanationPicture: this.explanationPicture,
        explanationMedia: this.explanationMedia,
        hints: this.hints,
      };
      // if (this.isPremiumGame(this.type) && !this.access.includes('premiumGames')) return;

      if (this.type === 'mcq') {
        game.parametersMcq = this.parametersMcq;
      } else if (this.type === 'mcqImage') {
        game.parametersMcq = this.parametersMcqImage;
      } else if (this.type === 'mcqSurvey') {
        // eslint-disable-next-line no-return-assign
        this.parametersMcq.answers.forEach((ans) => (ans.isCorrect = true));
        game.parametersMcq = this.parametersMcq;
      } else if (this.type === 'flashCode') {
        game.parametersFlashCode = this.parametersFlashCode;
      } else if (this.type === 'sort' || this.type === 'sortImage') {
        game.parametersSort = this.parametersSort;
      } else if (this.type === 'targetZone') {
        game.parametersTargetZone = this.parametersTargetZone;
      } else if (this.type === 'textInput') {
        game.parametersTextInput = this.parametersTextInput;
      } else if (this.type === 'anagram') {
        game.parametersAnagram = this.parametersAnagram;
      } else if (this.type === 'puzzle') {
        game.parametersPuzzle = this.parametersPuzzle;
      } else if (this.type === 'scrapPicture') {
        game.parametersScrap = this.parametersScrap;
      } else if (this.type === 'takePicture') {
        game.parametersTakePicture = this.parametersTakePicture;
      }
      this.$emit('update-game-content', game, this.gameId);
    },
    changeGameType() {
      // console.log('changeGameType:', this.isPremiumGame(this.type))
      // console.log('changeGameType:', this.access)
      // if ((this.isPremiumGame(this.type) && this.access.includes('premiumGames')) || (!this.isPremiumGame(this.type))) {
      // console.log("save update game ùùùù")
      // this.updateGame();
      // }
    },
    addAnswer(type) {
      if (type === 'mcq' && this.parametersMcq.answers.length < 4) {
        this.parametersMcq.answers = [
          ...this.parametersMcq.answers,
          { text: { fr: '', en: '' }, isCorrect: false },
        ];
      }
      if (type === 'mcqSurvey' && this.parametersMcq.answers.length < 4) {
        this.parametersMcq.answers = [
          ...this.parametersMcq.answers,
          { text: { fr: '', en: '' }, isCorrect: true },
        ];
      }
      if (type === 'mcqImage' && this.parametersMcqImage.answers.length < 4) {
        this.parametersMcqImage.answers = [
          ...this.parametersMcqImage.answers,
          { picture: { url: '' }, isCorrect: false },
        ];
      }
      if (
        (type === 'sort' || type === 'sortImage') &&
        this.parametersSort.sortElements.length < 4
      ) {
        this.parametersSort.sortElements = [
          ...this.parametersSort.sortElements,
          {
            picture: { url: '' },
            text: { fr: '', en: '' },
            expectedPosition: this.parametersSort.sortElements.length + 1,
          },
        ];
      }
    },
    addHint() {
      this.hints = [...this.hints, { text: { fr: '', en: '' } }];
    },
    setGameValues() {
      // console.log('setval game id',this.gameId)
      // console.log('game info picture', this.gameInformations.instruction.picture.url)
      // console.log('inst picture', this.instruction.picture.url)
      if (
        this.gameInformations.instruction &&
        this.gameInformations.instruction.text
      ) {
        this.langsEdited.forEach((lang) => {
          this.instruction.text[lang] =
            this.gameInformations.instruction.text[lang];
        });
      }
      if (
        this.gameInformations.instruction &&
        this.gameInformations.instruction.picture
      ) {
        //&& this.gameInformations.instruction.picture.url) {

        this.instruction.picture = this.gameInformations.instruction.picture;
      }
      if (
        this.gameInformations.instruction &&
        this.gameInformations.instruction.media
      ) {
        this.instruction.media = this.gameInformations.instruction.media;
      }
      if (this.gameInformations.type) {
        this.type = this.gameInformations.type;
      }
      if (this.gameInformations.explanation) {
        this.langsEdited.forEach((lang) => {
          this.explanation[lang] = this.gameInformations.explanation[lang];
        });
      }
      if (
        this.gameInformations.hints &&
        this.gameInformations.hints.length !== 0
      ) {
        this.hints = JSON.parse(JSON.stringify(this.gameInformations.hints));
        //this.langsEdited.forEach(lang=>{
        //  this.hints[0].text[lang]=this.gameInformations.hints[0].text[lang];
        //});
      }
      if (this.gameInformations.explanationPicture) {
        this.explanationPicture = this.gameInformations.explanationPicture;
      }
      if (this.gameInformations.explanationMedia) {
        this.explanationMedia = this.gameInformations.explanationMedia;
      }
      if (this.type === 'sort' || this.type === 'sortImage') {
        this.parametersSort = JSON.parse(
          JSON.stringify(this.gameInformations.parametersSort)
        ); // marche mais moche mais la réactivité d'un array est pas trop possible à enlever
      } else if (this.type === 'mcq' || this.type === 'mcqSurvey') {
        this.parametersMcq = JSON.parse(
          JSON.stringify(this.gameInformations.parametersMcq)
        );
      } else if (this.type === 'mcqImage') {
        this.parametersMcqImage = JSON.parse(
          JSON.stringify(this.gameInformations.parametersMcq)
        );
      } else if (this.type === 'goTo') {
        if (this.mission.geolocation && this.mission.geolocation.coordinates) {
          this.geolocation = this.mission.geolocation;
        }
      } else if (this.type === 'flashCode') {
        if (this.gameInformations.parametersFlashCode.codeValue) {
          this.flashCode = this.gameInformations.parametersFlashCode.codeValue;
        }
      } else if (this.type === 'targetZone') {
        if (this.gameInformations.parametersTargetZone) {
          this.parametersTargetZone =
            this.gameInformations.parametersTargetZone;
        }
      } else if (this.type === 'textInput' || this.type === 'anagram') {
        if (
          this.type === 'anagram' &&
          this.gameInformations.parametersAnagram
        ) {
          this.parametersAnagram = this.gameInformations.parametersAnagram;
        } else if (
          this.type === 'textInput' &&
          this.gameInformations.parametersTextInput
        ) {
          this.parametersTextInput = this.gameInformations.parametersTextInput;
        }
      } else if (this.type === 'puzzle') {
        if (this.gameInformations.parametersPuzzle) {
          this.parametersPuzzle = this.gameInformations.parametersPuzzle;
        }
      } else if (this.type === 'scrapPicture') {
        if (this.gameInformations.parametersScrap) {
          this.parametersScrap = this.gameInformations.parametersScrap;
        }
      } else if (this.type === 'takePicture') {
        if (this.gameInformations.parametersTakePicture) {
          this.parametersTakePicture =
            this.gameInformations.parametersTakePicture;
        }
      }
      if (this.type === 'mcqSurvey') {
        // eslint-disable-next-line no-return-assign
        this.parametersMcq.answers.forEach((ans) => (ans.isCorrect = true));
      }
    },
    stopDragSortGame() {
      this.isDragButtonSortGameClicked = false;
    },
    dragButtonSortGameClick() {
      this.isDragButtonSortGameClicked = true;
    },
    createNewGame() {
      this.isGameTypeDialogOpen = true;
      if (this.isFirstGame) {
        // 1er jeu: par défaut game find
        this.type = 'find';
      } else {
        this.type = 'mcq';
      }
      this.updateGame();
    },
    elementChosenToDrag() {
      this.isChosen = true;
      this.$emit('drag-button-click');
    },
    onImageError(error) {
      console.log('imageError', error.message);
    },
    updateInstructionImage(value) {
      this.instruction.picture = value;
      this.updateGame();
    },
    updateInstructionText() {
      if (
        this.instruction.text[this.langEdition] &&
        this.instruction.text[this.langEdition].length <=
          this.maxCharInstruction &&
        this.instruction.text[this.langEdition] !==
          this.gameInformations.instruction.text[this.langEdition]
      ) {
        this.updateGame();
      }
    },
    updateInstructionMedia(value) {
      this.instruction.media = value;
      this.updateGame();
    },
    updateMedia(payload) {
      this.instruction.media = payload;
      this.updateGame();
    },
    uploadingMedia(isUploading, percentProgress) {
      this.$emit('uploading-media', isUploading, percentProgress);
    },
    updateExplanation() {
      if (
        !this.gameInformations.explanation ||
        !this.gameInformations.explanation[this.langEdition] ||
        (this.gameInformations.explanation[this.langEdition] &&
          this.explanation[this.langEdition] !==
            this.gameInformations.explanation[this.langEdition] &&
          this.explanation[this.langEdition].length <= this.maxCharExplanation)
      ) {
        this.updateGame();
      }
    },
    updateHint(newTextValue, hintId) {
      this.hints[hintId].text[this.langEdition] = newTextValue;
      this.updateGame();
    },
    updateExplanationPicture(value) {
      this.explanationPicture = value;
      this.updateGame();
    },
    updateExplanationMedia(value) {
      this.explanationMedia = value;
      this.updateGame();
    },
    updateLocation(location) {
      this.geolocation = {
        type: 'point',
        coordinates: [location.latlng.lng, location.latlng.lat],
      };

      this.isLocationDialogOpen = false;
      this.locationBtnClass = '';
      this.$emit('update-geolocation', this.geolocation);
    },
    cancelLocationSubmit() {
      this.isLocationDialogOpen = false;
    },
    deleteLocation() {
      this.geolocation = null;
      this.isLocationDialogOpen = false;
      this.locationBtnClass = '';
      this.$emit('delete-geolocation');
    },
    updateFlashcode() {
      this.parametersFlashCode.codeValue = this.flashCode;
      this.updateGame();
    },
    deleteGame() {
      this.isGameTypeDialogOpen = false;
      this.$emit('delete-game', this.gameId);
    },
    updateAnswerValue(newValue, answerId, gameType) {
      if (this.type === 'mcq') {
        this.parametersMcq.answers[answerId].isCorrect = newValue;
      } else if (this.type === 'mcqImage') {
        this.parametersMcqImage.answers[answerId].isCorrect = newValue;
      }
      this.updateGame();
    },
    updateAnswerText(newTextValue, answerId) {
      this.parametersMcq.answers[answerId].text[this.langEdition] =
        newTextValue;
      this.updateGame();
    },
    updateAnswerImage(newImageValue, answerId) {
      if (answerId >= this.parametersMcqImage.answers.length) {
        //nouvelle réponse image
        this.addAnswer('mcqImage');
      }
      this.parametersMcqImage.answers[answerId].picture = newImageValue;
      this.updateGame();
    },
    updateTextGameAnswer(newTextValue) {
      if (this.type === 'textInput') {
        this.parametersTextInput.expectedValues[this.langEdition] =
          newTextValue;
      } else if (this.type === 'anagram') {
        this.parametersAnagram.phrase[this.langEdition] = newTextValue;
      }
      this.updateGame();
    },
    updateTakePictureAnswer(parameters) {
      this.parametersTakePicture = parameters;
      this.updateGame();
    },
    updatePuzzleParameters(parameters) {
      this.parametersPuzzle = parameters;
      this.updateGame();
    },
    updatePuzzleImage(image) {
      this.parametersPuzzle.picture = image;
      this.updateGame();
    },
    updateSortAnswer(newTextValue, position) {
      if (this.type === 'sort') {
        this.parametersSort.sortElements[position].text[this.langEdition] =
          newTextValue;
      } else if (this.type === 'sortImage' && newTextValue) {
        this.parametersSort.sortElements[position].picture = newTextValue;
      } else if (this.type === 'sortImage' && newTextValue === null) {
        this.parametersSort.sortElements[position].picture.url = '';
        this.parametersSort.sortElements[position].text.fr = '';
        this.parametersSort.sortElements[position].text.en = '';
      }
      this.updateGame();
    },
    updateTargetZoneImage(newImageValue) {
      this.parametersTargetZone.picture = newImageValue;
      this.updateGame();
    },
    updateScrapPictureAnswerImage(newImageValue) {
      this.parametersScrap.pictureToDiscover.url = newImageValue.url;
      this.parametersScrap.pictureToDiscover.author = newImageValue.author;
      this.parametersScrap.pictureToDiscover.legend = newImageValue.legend;
      this.updateGame();
    },
    updateScrapPictureCoverImage(newImageValue) {
      this.parametersScrap.coverPicture.url = newImageValue.url;
      this.parametersScrap.coverPicture.author = newImageValue.author;
      this.parametersScrap.coverPicture.legend = newImageValue.legend;
      this.updateGame();
    },
    updateScrapPictureCoverColor(newColorValue) {
      this.parametersScrap.coverColorHex = newColorValue;
      this.updateGame();
    },
    updateScrapPictureCoverType(type) {
      this.parametersScrap.coverType = type;
      this.updateGame();
    },
    updateTargetZone(newZone) {
      this.parametersTargetZone.zoneRelativeY = newZone.zoneRelativeY;
      this.parametersTargetZone.zoneRelativeX = newZone.zoneRelativeX;
      this.parametersTargetZone.zoneRelativeWidth = newZone.zoneRelativeWidth;
      this.parametersTargetZone.zoneRelativeHeight = newZone.zoneRelativeHeight;
      this.updateGame();
    },
    async updateTranslatedText(textTranslated, type) {
      if (textTranslated) {
        if (type === 'instruction') {
          this.instruction.text[this.langEdition] = textTranslated;
          this.updateInstructionText();
        } else if (type === 'explanation') {
          this.explanation[this.langEdition] = textTranslated;
          this.updateExplanation();
        }
      }
    },
    deleteHint(hintId) {
      this.hints.splice(hintId, 1);
      this.updateGame();
    },
    deleteAnswer(answerId, gameType) {
      if (gameType === 'mcq' || gameType === 'mcqSurvey') {
        this.parametersMcq.answers.splice(answerId, 1);
      } else if (gameType === 'mcqImage') {
        this.parametersMcqImage.answers.splice(answerId, 1);
      } else if (gameType === 'sort' || gameType === 'sortImage') {
        this.parametersSort.sortElements.splice(answerId, 1);
      }
      this.updateGame();
    },
    goPremium() {
      this.openPremiumDialog = true;
    },
    closePremium() {
      this.openPremiumDialog = false;
    },
    areObjectsEqual(obj1, obj2) {
      const keys1 = Object.keys(obj1);
      const keys2 = Object.keys(obj2);

      if (keys1.length !== keys2.length) {
        return false;
      }
      for (let key of keys1) {
        if (obj1[key] !== obj2[key]) {
          return false;
        }
      }
      return true;
    },
    checkObjectValues(obj) {
      for (var key in obj) {
        if (obj.hasOwnProperty(key)) {
          var value = obj[key];

          if (typeof value === 'object' && value !== null) {
            // L'élément est un objet imbriqué, vérifiez ses valeurs récursivement
            if (this.checkObjectValues(value)) {
              return true; // L'objet imbriqué contient une valeur
            }
          } else {
            // L'élément est une valeur primitive, vérifiez si ce n'est pas undefined
            if (
              value !== '' &&
              value !== null &&
              typeof value !== 'undefined'
            ) {
              return true; // L'objet contient une valeur
            }
          }
        }
      }
      return false;
    },

    objectIsEmpty(labelTab) {
      let obj = {};
      if (labelTab === 'instructions') {
        obj = { p: this.instruction.picture, m: this.instruction.media };
      } else if (labelTab === 'explanations') {
        obj = {
          e: this.explanation,
          p: this.explanationPicture,
          m: this.explanationMedia,
        };
      } else if (labelTab === 'hints') {
        this.hints.forEach((h, i) => (obj[i] = h));
      }
      return this.checkObjectValues(obj);
    },
  },
  watch: {
    gameId(newValue) {
      console.log('watch gameid', newValue);
      if (this.gameInformations.type) {
        this.setGameValues();
        // this.updateGame();
      } else {
        this.createNewGame();
      }
    },
    instruction(newValue) {
      return newValue;
    },
    explanation(newValue) {
      return newValue;
    },
    hints(newValue) {
      return newValue;
    },
    orderGame(newValue) {
      return newValue;
    },
    type(newValue) {
      return newValue;
    },
    parametersSort(newValue) {
      return newValue;
    },
    parametersMcq(newValue) {
      return newValue;
    },
    parametersMcqImage(newValue) {
      return newValue;
    },
    parametersFlashCode(newValue) {
      return newValue;
    },
    parametersScrap(newValue) {
      return newValue;
    },
    parametersTakePicture(newValue) {
      return newValue;
    },
    parametersTargetZone(newValue) {
      return newValue;
    },
    flashCode(newValue) {
      return newValue;
    },
    isDrag() {
      if (this.isDrag === false) {
        this.isChosen = false;
      }
    },
    validGameForm(newValue) {
      this.$emit(
        'valid-game-form',
        newValue && this.invalidGamesInformations.length === 0,
        this.orderGame
      );
      return newValue;
    },

    langEdition(newValue) {
      this.$refs.gameForm.resetValidation();
      return newValue;
    },
  },
};
</script>

<style lang="sass" >
@import '../assets/_vars.scss'
.layoutHeight
  height: 25vh


.v-expansion-panel__body
  min-height: 440px;

.tab-item-wrapper
  /* vuetify sets the v-tabs__container height to 48px */
  height: calc(100vh - 48px)

.v-tabs__container
  justify-content: center;

.expand-transition
  -webkit-transition: max-height 1s;
  -moz-transition: max-height 1s;
  -ms-transition: max-height 1s;
  -o-transition: max-height 1s;
  transition: max-height 1s;

.missionForm__game
  margin-top: 0px;
  margin-bottom: 15px;
  height: 64px;

.missionForm__game .v-input--selection-controls__input
  display: none !important

.v-input--selection-controls
  margin-top: 0px

.MissionForm__gameIcon
  width: 60px
  height: 60px
  border: 1px solid $secondary
  border-radius: 4px
  display: flex
  justify-content: center
  margin: 0em 2em 0em 2em
  i
    color: $secondary !important
.MissionForm__gameIcon--selected
  background: $primary

.MissionForm__newGameIcon
  width: 60px
  height: 60px
  border: 0px solid $secondary
  border-radius: 4px
  display: flex
  justify-content: center
  margin: 0em 2em 1em 2em
  &:first-of-type
    margin-left: 0.2em

.MissionForm__close
  position: absolute
  top: 12px
  right: 20px
  cursor: pointer

.gameTypeLabel
  margin: 0.3em 2em 1em 3.5em
  font-size: 10px
  line-height: 15px
  color: $secondary

.addGame
  width: 300px
  height: 52px
  border: 2px dashed #009999
  border-radius: 4px
  margin-right: 30px;

.addHint
  width: 150px
  height: 40px
  border: 2px dashed #009999
  border-radius: 4px

.addSortGame
  width: 300px
  height: 52px
  border: 2px dashed #009999
  border-radius: 4px
  margin-left: 30px
  display: flex
  justify-content: center

.fileinput
  display: none

.flashCodeField
  max-width: 250px
  max-height: 60px

.pointerClass
  cursor: pointer

.addSortImageGame
  margin-top: 8px
  width: 150px
  height: 180px
  border: 2px dashed #009999
  border-radius: 4px
  margin-left: 30px
  display: flex
  justify-content: center

.addThirdImage
  left: 0px
  background: white
  cursor: pointer
  display: flex
  border-radius: 4px
  margin-right: 225px
  margin-top: 18px

  div
    width: 150px
    height: 90px
    border: 2px dashed #009999
    border-radius: 2px
    display: flex
    justify-content: center
    align-items: center

.addFourthImage
  position: absolute
  background: white
  cursor: pointer
  display: flex
  border-radius: 4px
  margin-left: 150px
  margin-top: 143px

  div
    width: 150px
    height: 90px
    border: 2px dashed #009999
    border-radius: 2px
    display: flex
    justify-content: center
    align-items: center

.readOnlyClass
  pointer-events: none;

.ruleText
  color: red;
  font-size: small;
  text-align: center;
  line-height: 120%;
  margin-top: 10px;

.switch
  max-width: 40px
  margin-left: 15px
</style>
